// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".datepicker-container{color:#636363;font-size:14px;flex-grow:1}.form-control{color:#636363;display:block;height:35px;padding:.8rem;padding-left:35px;font-size:17px;line-height:1.5;background-clip:padding-box}.calendar{position:absolute;margin-left:9px;height:37px;display:flex;align-items:center;z-index:1000;font-size:22px;color:#d0d0d0}.format-help{position:absolute;right:9px;max-width:50%;line-height:1.12;color:#777}", ""]);
// Exports
module.exports = exports;
